import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export const Wrapper = styled(Box)``;

export const CompanyNameLink = styled(Link)`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: ${(p) => p.theme.typography.fontWeightSemiBold};
  font-size: ${(p) => p.theme.typography.body3.fontSize};
  color: ${(p) => p.theme.palette.grey[700]};
  line-height: normal;
  text-decoration: none;
  &:hover {
    color: ${(p) => p.theme.palette.primary[500]};
    text-decoration: underline;
  }
`;
